const footerLinks: Record<string, string[]> = {
  "제품": ["기능 소개", "대시보드", "분석 도구", "연동 서비스", "요금제", "API 문서"],
  "회사": ["회사 소개", "채용", "블로그", "보도자료", "파트너십"],
  "리소스": ["고객센터", "문서", "커뮤니티", "서비스 현황", "문의하기"],
  "법적 고지": ["개인정보처리방침", "이용약관", "쿠키 설정", "GDPR"],
};

const socials = [
  { icon: "ri-twitter-x-line", href: "#" },
  { icon: "ri-linkedin-box-line", href: "#" },
  { icon: "ri-github-line", href: "#" },
  { icon: "ri-youtube-line", href: "#" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A0E14] border-t border-white/8">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="https://public.readdy.ai/ai/img_res/35b72bf3-4b7f-4858-926b-243fdf4afa99.png" alt="StreamClip AI" className="h-8 w-8 object-contain" />
              <span className="text-white font-bold text-lg" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                StreamClip<span className="text-[#00D9FF]">AI</span>
              </span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-6 max-w-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
              케이블TV·종편·지상파 방송 콘텐츠를 AI로 분석해 바이럴 숏폼으로 자동 변환하는 제작 자동화 플랫폼.
            </p>
            <div className="flex items-center gap-3">
              {socials.map((s) => (
                <a key={s.icon} href={s.href} className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/8 text-gray-500 hover:text-[#00D9FF] hover:border-[#00D9FF]/30 transition-all duration-200 cursor-pointer">
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h5 className="text-white text-xs font-bold uppercase tracking-widest mb-5" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{title}</h5>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link}>
                    <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors cursor-pointer" rel="nofollow" style={{ fontFamily: "'Inter', sans-serif" }}>{link}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-white/6">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            © 2026 StreamClipAI Inc. 모든 권리 보유.
          </p>
          <div className="flex items-center gap-2 text-xs" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
            <span className="w-1.5 h-1.5 rounded-full bg-[#10B981] animate-pulse inline-block" />
            <span className="text-gray-600">모든 시스템 정상 운영 중</span>
            <span className="text-gray-700 mx-2">·</span>
            <span className="text-gray-600">v3.2.1</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
